export default __webpack_public_path__ + "static/media/natureswrath.a5b4678a.png";